import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForDivisionComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'name'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
  ];
}
